var usercentricsLoaded = false;
function loadUsercentrics() {
  if (usercentricsLoaded) return;
  usercentricsLoaded = true;

  var head = document.getElementsByTagName("head")[0] || document.documentElement;

  // Load TCF stub script
  var tcf_stub = document.createElement("script");
  tcf_stub.src = "https://web.cmp.usercentrics.eu/tcf/stub.js";

  // Read settings ID from the script tag's data attribute
  var currentScript = document.querySelector('script[data-uc-settings-id]');
  var settingsId = currentScript ? currentScript.getAttribute('data-uc-settings-id') : 'wVsgQTaMV';

  var usercentrics_script = document.createElement("script");
  usercentrics_script.id = "usercentrics-cmp";
  usercentrics_script.async = true;
  usercentrics_script.setAttribute("data-settings-id", settingsId);

  // All markets use CMP v3; only their settings IDs differ.
  usercentrics_script.src = "https://web.cmp.usercentrics.eu/ui/loader.js";

  // Register before starting the CMP and retain consent while Shopify initializes.
  var latestConsent = null;
  var shopifyConsentReady = false;
  function syncConsent(detail) {
    const services = Object.values(detail.services);
    const ucAnalytics = services.find(service => service.name === 'Shopify Analytics');
    const ucMarketing = services.find(service => service.name === 'Shopify Marketing');
    const ucPreferences = services.find(service => service.name === 'Shopify Preferences');
    if (!ucAnalytics || !ucMarketing || !ucPreferences) {
      console.warn('[Usercentrics] Missing Shopify consent services');
      return;
    }
    var consent = {
      analytics: !!(ucAnalytics.consent && ucAnalytics.consent.given === true),
      marketing: !!(ucMarketing.consent && ucMarketing.consent.given === true),
      preferences: !!(ucPreferences.consent && ucPreferences.consent.given === true)
    };
    if (window.Shopify.customerPrivacy.saleOfDataRegion()) {
      if (!detail.consent || !detail.consent.status) return;
      var allowed = detail.consent.status !== 'ALL_DENIED';
      consent = {
        analytics: allowed,
        marketing: allowed,
        preferences: allowed,
        sale_of_data: allowed
      };
    }
    window.Shopify.customerPrivacy.setTrackingConsent(consent, function() {
      console.log('[Usercentrics] Consent synced with Shopify');
    });
  }
  window.addEventListener('UC_CONSENT', function(event) {
    if (!event.detail || !event.detail.services) return;
    latestConsent = event.detail;
    if (shopifyConsentReady) syncConsent(latestConsent);
  });

  // Match the supplied snippet: execute the TCF stub before the async v3 loader.
  tcf_stub.onload = function() {
    head.appendChild(usercentrics_script);
  };
  head.appendChild(tcf_stub);

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function(error) {
      if (error) {
        console.error('[Usercentrics] Shopify Consent Tracking API failed to load', error);
        return;
      }
      shopifyConsentReady = true;
      if (latestConsent) syncConsent(latestConsent);
    }
  );
}
loadUsercentrics();
